import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { v4 as uuidv4 } from 'uuid';
import { adminApi } from '../../api';


export default function AddCouponPanel() {
  const [formData, setFormData] = useState({
    couponCode: '',
    redemptionType: 'credit',
    redemptionValue: 0,
    redemptionMonths: 0,
    redemptionLimit: 0,
    redemptionStartDate: new Date(),
    redemptionEndDate: new Date(),
    redemptionActive: true,
    redemptionPercentage: 0, // Field for percentage discount
    isPercentRedemption: false, // New field to indicate percentage redemption
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    
    // Check for changes in redemption type to set isPercentRedemption
    if (name === 'redemptionType') {
      const isPercent = value === 'percentage';
      setFormData((prevFormData) => ({
        ...prevFormData,
        isPercentRedemption: isPercent,
      }));
    }
  };

  const handleDateChange = (name, date) => {
    setFormData({
      ...formData,
      [name]: date,
    });
  };

  const handleGenerateCode = () => {
    const generatedCode = uuidv4().slice(0, 8).toUpperCase();
    setFormData({
      ...formData,
      couponCode: generatedCode,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await adminApi.post('/admin/coupon/create', formData);
      console.log('Coupon created successfully:', response.data);
      // Optionally reset the form or provide user feedback
    } catch (error) {
      console.error('Error creating coupon:', error);
    }
  };

  return (
    <div className="max-w-3xl rounded-lg border border-gray-700 bg-gray-900/60 p-5 text-left text-white sm:p-6">
      <h2 className="mb-5 text-lg font-semibold">Add New Coupon</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Coupon Code</label>
          <div className="flex items-center">
            <input
              type="text"
              name="couponCode"
              value={formData.couponCode}
              onChange={handleChange}
              className="w-full p-2 rounded bg-gray-700 text-white"
              required
            />
            <button
              type="button"
              onClick={handleGenerateCode}
              className="ml-2 bg-blue-600 hover:bg-blue-700 p-2 rounded text-white"
            >
              Generate Code
            </button>
          </div>
        </div>
        <div>
          <label className="block mb-1">Redemption Type</label>
          <select
            name="redemptionType"
            value={formData.redemptionType}
            onChange={handleChange}
            className="w-full p-2 rounded bg-gray-700 text-white"
          >
            <option value="credit">Credit</option>
            <option value="subscription">Subscription</option>
            <option value="percentage">Percentage Discount</option>
          </select>
        </div>
        {formData.redemptionType === 'credit' && (
          <div>
            <label className="block mb-1">Redemption Value</label>
            <input
              type="number"
              name="redemptionValue"
              value={formData.redemptionValue}
              onChange={handleChange}
              className="w-full p-2 rounded bg-gray-700 text-white"
              required
            />
          </div>
        )}
        {formData.redemptionType === 'subscription' && (
          <div>
            <label className="block mb-1">Redemption Months</label>
            <input
              type="number"
              name="redemptionMonths"
              value={formData.redemptionMonths}
              onChange={handleChange}
              className="w-full p-2 rounded bg-gray-700 text-white"
              required
            />
          </div>
        )}
        {formData.redemptionType === 'percentage' && (
          <div>
            <label className="block mb-1">Redemption Percentage (%)</label>
            <input
              type="number"
              name="redemptionPercentage"
              value={formData.redemptionPercentage}
              onChange={handleChange}
              className="w-full p-2 rounded bg-gray-700 text-white"
              required
            />
          </div>
        )}
        <div>
          <label className="block mb-1">Redemption Limit</label>
          <input
            type="number"
            name="redemptionLimit"
            value={formData.redemptionLimit}
            onChange={handleChange}
            className="w-full p-2 rounded bg-gray-700 text-white"
            required
          />
        </div>
        <div>
          <label className="block mb-1">Redemption Start Date</label>
          <DatePicker
            selected={formData.redemptionStartDate}
            onChange={(date) => handleDateChange('redemptionStartDate', date)}
            className="w-full p-2 rounded bg-gray-700 text-white"
            dateFormat="yyyy/MM/dd"
            showTimeSelect
            placeholderText="Select start date"
          />
        </div>
        <div>
          <label className="block mb-1">Redemption End Date</label>
          <DatePicker
            selected={formData.redemptionEndDate}
            onChange={(date) => handleDateChange('redemptionEndDate', date)}
            className="w-full p-2 rounded bg-gray-700 text-white"
            dateFormat="yyyy/MM/dd"
            showTimeSelect
            placeholderText="Select end date"
          />
        </div>
        <div>
          <label className="block mb-1">Redemption Active</label>
          <input
            type="checkbox"
            name="redemptionActive"
            checked={formData.redemptionActive}
            onChange={handleChange}
            className="mr-2"
          />
          <span>Active</span>
        </div>
        <button
          type="submit"
          className="bg-blue-600 hover:bg-blue-700 p-2 rounded text-white"
        >
          Create Coupon
        </button>
      </form>
    </div>
  );
}
